<template>
  <main>
    <div class="grid dashboard">
      <chart-generator :chart="chart" v-for="chart in charts" :key="chart"></chart-generator>
    </div>
  </main>
</template>

<script>
import store from "@/store";
import ChartGenerator from "../../components/ChartGenerator";

export default {
  data() {
    return {}
  },
  components: {
    ChartGenerator
  },
  mounted() {
    store.dispatch("getDashboardData");
  },
  methods: {
    getColors() {
      const isLight = this.$appState.layoutMode === 'light';
      return {

        dataset1Color: isLight ? '#00ACC1' : '#4DD0E1',
        dataset2Color: isLight ? '#FF9800' : '#FFB74D',
        blueColor: isLight ? '#42A5F5' : '#90CAF9',
        grayColor: isLight ? '#78909C' : '#78909C',
        tealColor: isLight ? '#26A69A' : '#80CBC4',
        pearColor: isLight ? '#c0ca33' : '#dce775',
        orange2Color: isLight ? '#d35400' : '#d35400',
        limeColor: isLight ? '#D4E157' : '#E6EE9C',
        orangeColor: isLight ? '#FFA726' : '#FFCC80',
        lightblueColor: isLight ? '#29B6F6' : '#81D4FA',
        deeppurpleColor: isLight ? '#7E57C2' : '#B39DDB',
        indigoColor: isLight ? '#5C6BC0' : '#9FA8DA',
        pinkColor: isLight ? '#EC407A' : '#F48FB1',
        cyanColor: isLight ? '#00ACC1' : '#4DD0E1',
        purpleColor: isLight ? '#AB47BC' : '#CE93D8',
        greenColor: isLight ? '#66BB6A' : '#A5D6A7',
        lightgreenColor: isLight ? '#9CCC65' : '#C5E1A5',
        yellowColor: isLight ? '#FFEE58' : '#FFF59D',
        amberColor: isLight ? '#FFCA28' : '#FFE082',
        deeporangeColor: isLight ? '#FF7043' : '#FFAB91',
        brownColor: isLight ? '#8D6E63' : '#BCAAA4',
        teal2Color: isLight ? '#00838F' : '#26c6da',
        spanishOrange2Color: isLight ? '#ef6c00' : '#ffb74d',
        blueFranceColor: isLight ? '#1e88e5' : '#64b5f6',
        stateGrayColor: isLight ? '#607d8b' : '#90a4ae',
        darkCyanColor: isLight ? '#00897b' : '#4db6ac',
      }
    },
    formatYearLabel(year) {
      let nextYear = parseInt(year) + 1;
      return `${year} - ${nextYear}`;
    }

  },
  computed: {
    chart_data() {
      return store.state.dashboard.data
    },
    charts() {

      return [
        {"name": "bakalavr_internatura", "type": "bar", "data": this.convertQualitativeComposition['Бакалавриат + интернатура']},
        {"name": "rezidentura", "type": "bar", "data": this.convertQualitativeComposition['Резидентура']},
        {"name": "magistartura", "type": "bar", "data": this.convertQualitativeComposition['Магистратура']},
        {"name": "doktarantura", "type": "bar", "data": this.convertQualitativeComposition['Докторантура']},
      ]
    },
    loading() {
      return store.state.dashboard.loading
    },

    convertQualitativeComposition() {
      if (!this.chart_data.student_by_degree || Object.keys(this.chart_data.student_by_degree).length === 0)
        return {
          labels: [],
          datasets: []
        }
// Separate data by degree level
      const studentByDegree = {
        "Бакалавриат + интернатура": [],
        "Резидентура": [],
        "Магистратура": [],
        "Докторантура": []
      };
      for (let i = 0; i < this.chart_data.student_by_degree.length; i++) {
        const item = this.chart_data.student_by_degree[i];
        studentByDegree[item.degree_level].push({
          year: item.year,
          finance_type: item.finance_type,
          count: item.count
        });
      }
      console.log(studentByDegree)
// Prepare ChartJS data for each degree level
      const chartData = {};
      const degrees = Object.keys(studentByDegree);
      for (let i = 0; i < degrees.length; i++) {
        const degree = degrees[i];
        const chartLabels = [];
        const chartDataSets = [];
        const financeTypes = ["Грант", "Договор", "МИО"];
        for (let j = 0; j < financeTypes.length; j++) {
          const financeType = financeTypes[j];
          const chartDataPoints = [];
          for (let k = 0; k < studentByDegree[degree].length; k++) {
            const item = studentByDegree[degree][k];
            if (item.finance_type == financeType) {
              chartDataPoints.push(item.count);
              if (chartLabels.indexOf(this.formatYearLabel(item.year)) === -1) {
                chartLabels.push(this.formatYearLabel(item.year));
              }
            }
          }
          chartDataSets.push({
            label: financeType,
            data: chartDataPoints,
            backgroundColor: Object.values(this.getColors())[j],
          });
        }
        chartData[degree] = {
          labels: chartLabels,
          datasets: chartDataSets
        };
      }
      return chartData
    }
  }
}
</script>
